import React, { FC } from "react";
import { Redirect } from "react-router";
import { routes } from "routes/routes";

export const User: FC = () => <Redirect to={routes.account.index.create({})} />;
